<ion-row class="ion-align-items-center">
  <ion-col size="auto" class="center" *ngIf="showIcon">
    <ion-icon [name]="iconName" [color]="iconColor" [size]="iconSize"></ion-icon>
  </ion-col>
  <ion-col size="10">
    <ion-label [color]="labelColor" class="{{ labelWeight }} {{ labelSize }}" [ngStyle]="fontSize ? {fontSize} : {}">{{ label }} </ion-label>
  </ion-col>
</ion-row>
